import { createElement } from "react";
import TimerRemote from "./TimerRemote";
import { displayOpen, displayClose, remoteClose } from "src/pods/realtime";
import { useToolkitRealtimeStore } from "src/pods/realtime/toolkitRealtimeStore";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";
import { sendTime } from "src/pods/timer";
import { useToolkitTimerStore } from "src/pods/timer/toolkitTimerStore";

type TimerRemoteContainerProps = {
  params: {
    classId: string;
    mountPoint: string;
  };
};

export default function TimerRemoteContainer({ params }: TimerRemoteContainerProps) {
  const time = useToolkitTimerStore();
  const { displayOn: isCasting, paired: isConnected } = useToolkitRealtimeStore();

  return createElement(TimerRemote, {
    classId: params.classId,
    mountPoint: params.mountPoint,
    time,
    isCasting,
    isConnected,
    sendTime: (payload) => dispatchToolkitReduxAction(sendTime(payload)),
    displayOpen: (path, action) => dispatchToolkitReduxAction(displayOpen(path, action)),
    displayClose: () => dispatchToolkitReduxAction(displayClose()),
    remoteClose: () => dispatchToolkitReduxAction(remoteClose()),
  });
}
